'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'book-bookmark';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e0bb';
var svgPathData = ['M48 48l0 313.6c12-6.1 25.6-9.6 40-9.6l312 0 0-304-48 0 0 176-80-48-80 48 0-176-144 0z', 'M0 0l448 0 0 400-32 0 0 64 32 0 0 48-448 0 0-72c0-2.7 .1-5.4 .4-8L0 432 0 0zM88 400c-22.1 0-40 17.9-40 40l0 24 320 0 0-64-280 0zM48 361.6c12-6.1 25.6-9.6 40-9.6l312 0 0-304-48 0 0 176-80-48-80 48 0-176-144 0 0 313.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;